var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 7,
    viewBox: "0 0 220 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "line",
    width: 220,
    height: 7,
    rx: 3.5,
    fill: "#e4002f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedline);
export default __webpack_public_path__ + "static/media/redline.031746c00f60b73736bcc2bd1fec588c.svg";
export { ForwardRef as ReactComponent };